export interface MenuItem {
  id: number;
  page: string;
  title: string;
  link: string;
  has_dropdown: boolean;
  sub_menus?: {
    link: string;
    title: string;
    commingSoon?: boolean;
    onClick?: (callback: () => void) => void;
  }[];
}

const menu_data: MenuItem[] = [
  // {
  //   id: 1,
  //   page: "nav_1",
  //   has_dropdown: true,
  //   title: "Home",
  //   link: "#",
  //   sub_menus: [
  //     { link: "/", title: "ICO Investment" },
  //     { link: "/home-two", title: "Blockchain" },
  //   ],
  // },
  // {
  //   id: 2,
  //   page: "nav_1",
  //   has_dropdown: false,
  //   title: "Feature",
  //   link: "/#feature",
  // },
  // {
  //   id: 3,
  //   page: "nav_1",
  //   has_dropdown: false,
  //   title: "RoadMap",
  //   link: "/#roadMap",
  // },
  // {
  //   id: 4,
  //   page: "nav_1",
  //   has_dropdown: true,
  //   title: "Blog",
  //   link: "#",
  //   sub_menus: [
  //     { link: "/blog", title: "Our Blog" },
  //     { link: "/blog-details", title: "Blog-Details" },
  //   ],
  // },
  // {
  //   id: 5,
  //   page: "nav_1",
  //   has_dropdown: false,
  //   title: "Contact",
  //   link: "/contact",
  // },

  {
    id: 1,
    page: "nav_2",
    has_dropdown: false,
    title: "Home",
    link: "/",
  },
  {
    id: 2,
    page: "nav_2",
    has_dropdown: false,
    title: "Why BitPrimax",
    link: "/#blockchain",
  },
  {
    id: 3,
    page: "nav_2",
    has_dropdown: false,
    title: "How it works",
    link: "/#how-it-works",
  },
  {
    id: 4,
    page: "nav_2",
    has_dropdown: false,
    title: "Sell Crypto",
    link: "/trade",
    // sub_menus: [
    //   { link: "#", title: "Buy Crypto", commingSoon: true },
    //   {
    //     link: "/trade",
    //     title: "Sell Crypto",
    //     onClick: (callback) => callback(),
    //   },
    // ],
  },
  // {
  //   id: 5,
  //   page: "nav_2",
  //   has_dropdown: false,
  //   title: "Contact",
  //   link: "/contact",
  // },
];

export const admin_menu_data: MenuItem[] = [
  {
    id: 0,
    page: "nav_2",
    has_dropdown: false,
    title: "Overview",
    link: "/admin/dashboard",
  },
  {
    id: 1,
    page: "nav_2",
    has_dropdown: false,
    title: "Users",
    link: "/admin/dashboard/users",
  },
  {
    id: 1.5,
    page: "nav_2",
    has_dropdown: false,
    title: "Transactions",
    link: "/admin/dashboard/transactions",
  },
  {
    id: 3,
    page: "nav_2",
    has_dropdown: false,
    title: "Withdrawals",
    link: "/admin/dashboard/withdrawals",
  },
  {
    id: 2,
    page: "nav_2",
    has_dropdown: false,
    title: "BPX Wallets",
    link: "/admin/dashboard/temp-wallets",
  },
];

export default menu_data;
